import { memo, useEffect, useState } from "react";
import ListUi from "./ListUi";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal, openModal } from "../../store/actions/modalAction";
import {
  Box,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { useMemo } from "react";
import CreateController from "./CreateController";
import MessageDilog from "../../components/MessageDilog";
import {
  Delete,
  Edit,
} from "@mui/icons-material";
import {
  deleteTopicField,
} from "../../apis/topic.api";
import { deleteAudioTrackField, getAudioTrackApi } from "../../apis/audioTrack.api";

const ActionComponent = memo(({ params, setParams, deleteApi, modalKey }) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const onEdit = () => {
    dispatch(
      openModal(
        <CreateController
          id={params._id}
          name={params.name}
          url={params.url}
          callBack={(response, updatedData) => {
            setParams({ ...params, ...updatedData });
          }}
        />,
        "sm",
        false,
        "audio"
      )
    );
  };

  const deleteFun = async () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await deleteApi({ id: params._id, fileUrl: params.url }),
        (response) => {
          setParams({});
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
    dispatch(closeModal());
  };
  const onDelete = () => {
    dispatch(
      openModal(
        <MessageDilog
          onSubmit={deleteFun}
          title="Alert!"
          message={`Are you sure to delete "${params.name || params.title}" ?`}
        />,
        "sm"
        // dispatch(callSnackBar("Topic Deleted Successfully..",SNACK_BAR_VARIETNS.suceess))
      )
    );
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      <IconButton disabled={loading} size="inherit" onClick={onEdit}>
        <Edit color="info" fontSize="inherit" />
      </IconButton>
      <>
        {loading && <CircularProgress color="primary" fontSize="inherit" />}
        {!loading && (
          <IconButton disabled={loading} size="inherit" onClick={onDelete}>
            <Delete color="error" fontSize="inherit" />
          </IconButton>
        )}
      </>
    </Box>
  );
});


const ListController = () => {
  const dispatch = useDispatch();

  const title = "Audio Track List";
  const fetchApi = getAudioTrackApi;
  const deleteApi = deleteAudioTrackField;

  const columns = useMemo(
    () => [
      {
        id: 1,
        minWidth: "50px",
        fieldName: "name",
        label: "Audio Name",
        align: "left",
        sort: true,
      },
      {
        id: 2,
        minWidth: "50px",
        fieldName: "name",
        label: "Audio Track",
        align: "left",
        sort: true,
        renderValue: (params) => (
          <audio controls>
            <source src={params.url} type="audio/mpeg" />
          </audio>
        ),
      },
      {
        id: 3,
        fieldName: "",
        label: "Action",

        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            deleteApi={deleteApi}
            params={params}
            setParams={setParams}
          />
        ),
      },
    ],
    [dispatch]
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["title"],
    sort: "createdAt",
    sortDirection: -1,
  });

  // do not change

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState({});

  const fetchList = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await fetchApi({ ...filters }),
        (response) => {
          setList(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };
  const onCreateBtnClick = () => {
    dispatch(
      openModal(
        <CreateController
          callBack={async () => {
            fetchList();
          }}
        />,
        "sm",
        false,
        "audio"
      )
    );
  };

  useEffect(() => {
    fetchList();
  }, [filters]);

  return (
    <>
      <ListUi
        title={title}
        onCreateBtnClick={onCreateBtnClick}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        list={list}
        columns={columns}
      />
    </>
  );
};
export default ListController;
